import {
  NodeBasicPage,
  NodeLandingPage,
  NodeProgram,
  NodeOnboarding,
  NodeDiary,
  NodeForum,
  NodeTip,
  NodeFrontPage,
  NodeHelp,
  NodeQuestionFaq,
  NodeJoyride,
} from '../implementations';

const mappers = {
  basic_page: NodeBasicPage,
  landing_page: NodeLandingPage,
  program: NodeProgram,
  onboarding: NodeOnboarding,
  diary_entry: NodeDiary,
  forum: NodeForum,
  tip: NodeTip,
  frontpage: NodeFrontPage,
  help: NodeHelp,
  faq: NodeQuestionFaq,
  joyride: NodeJoyride,
};

export default mappers;
